import React from 'react'
import FormWrapper from '../../../layout/formLayout/FormWrapper'
import LoginForm from '../../../components/auth/Login'
import Header from '../../../components/form/Header'

export default function Login() {
    return (
        <>
            <FormWrapper>
                <div>
                    <Header title="Collage Login" />
                    <LoginForm category='colleges' redirect="/college" />
                </div>
            </FormWrapper>
        </>
    )
}
